import React from "react";
import "./footer.scss";

const Footer = () => {
  return (
    <section className="footerContainer">
      <div className="footer">
        <div className="footerInfos">
          <div className="footerInfo">
            <span className="footerInfo__title">Nur Alam</span>
            <span className="footerInfo__desc">
              I prioritize sustainability and Client’s satisfaction in
              everything i can do.
            </span>
          </div>
        </div>

        {/* <div className="footerCopyRight">
          <p>© 2023 nur-alam All Rights Reserved</p>
        </div> */}

        <div className="footer_dContainer">
          <div className="fdc_itemContainer">
            <span className="fdc_header">Support</span>

            <a href="#contact" className="fdc_link">
              <span className="mobileMenu__contentItemText">Contact</span>
            </a>
          </div>

          <div className="fdc_itemContainer">
            <span className="fdc_header">Address</span>

            <span className="fdc_desc">
              Plot # 10, Road # 10, Block # 10, EAST KAZIPARA, <br />
              MIRPUR, DHAKA-1216
            </span>
          </div>
        </div>

        <div className="footerSocialMedia">
          <span className="sm_header"> Follow me</span>

          <div className="sm_container">
            <a
              href="https://www.facebook.com/nuralam.noyon.5"
              className="footer__socialIcon"
            >
              <i className="fab fa-facebook-f"></i>
            </a>

            <a
              href="https://www.linkedin.com/in/nur-alam-noyon-2835681b8/"
              className="footer__socialIcon"
            >
              <i className="fab fa-linkedin-in"></i>
            </a>

            <a
              href="https://www.instagram.com/nur_alam_noyon/"
              className="footer__socialIcon"
            >
              <i className="fab fa-instagram"></i>
            </a>

            <a
              href="https://x.com/nuralamnoyon03"
              className="footer__socialIcon"
            >
              <i className="fab fa-twitter"></i>
            </a>

            <a
              href="https://www.tiktok.com/@nur_alam_noyon?_t=8sF2qJFbgfA&_r=1"
              className="footer__socialIcon"
            >
              {/* <i className="fab fa-instagram"></i> */}

              <i className="fab fa-tiktok"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
